import {
  CAMPAIGN_LIST_REQUEST,
  CAMPAIGN_LIST_SUCCESS,
  CAMPAIGN_LIST_FAIL,
} from "../constant/CampaignConstant";

export const campaignListReducer = (state = {}, action) => {
  switch (action.type) {
    case CAMPAIGN_LIST_REQUEST:
      return { loading: true };
    case CAMPAIGN_LIST_SUCCESS:
      return { loading: false, campaignRecords: action.payload };
    case CAMPAIGN_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


